/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BarcodeContainment } from '../models/BarcodeContainment';
import type { BarcodeContainmentResult } from '../models/BarcodeContainmentResult';
import type { BarcodeCreate } from '../models/BarcodeCreate';
import type { BarcodeLookup } from '../models/BarcodeLookup';
import type { ObjectOut } from '../models/ObjectOut';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class BarcodesService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Get Barcode
     * @returns ObjectOut Successful Response
     * @throws ApiError
     */
    public getBarcodeApiV1BarcodesCodeGet({
        code,
    }: {
        code: string,
    }): CancelablePromise<Array<ObjectOut>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/barcodes/{code}',
            path: {
                'code': code,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Lookup Barcode
     * @returns ObjectOut Successful Response
     * @throws ApiError
     */
    public lookupBarcodeApiV1BarcodesLookupPost({
        requestBody,
    }: {
        requestBody: BarcodeLookup,
    }): CancelablePromise<Array<ObjectOut>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/v1/barcodes/lookup',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Create New Barcode
     * @returns any Successful Response
     * @throws ApiError
     */
    public createNewBarcodeApiV1BarcodesPut({
        requestBody,
    }: {
        requestBody: BarcodeCreate,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/api/v1/barcodes/',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                409: `Conflict`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Create New Barcode Via Url Params
     * @returns ObjectOut Successful Response
     * @throws ApiError
     */
    public createNewBarcodeViaUrlParamsApiV1BarcodesObjectIdTypeCodePut({
        objectId,
        code,
        type,
    }: {
        objectId: number,
        code: string,
        type: 'default' | 'code_128' | 'qr_code',
    }): CancelablePromise<ObjectOut> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/api/v1/barcodes/{object_id}/{type}/{code}',
            path: {
                'object_id': objectId,
                'code': code,
                'type': type,
            },
            errors: {
                409: `Conflict`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Create New Barcode Via Url Params
     * @returns ObjectOut Successful Response
     * @throws ApiError
     */
    public createNewBarcodeViaUrlParamsApiV1BarcodesObjectIdCodePut({
        objectId,
        code,
        type = 'default',
    }: {
        objectId: number,
        code: string,
        type?: 'default' | 'code_128' | 'qr_code',
    }): CancelablePromise<ObjectOut> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/api/v1/barcodes/{object_id}/{code}',
            path: {
                'object_id': objectId,
                'code': code,
            },
            query: {
                'type': type,
            },
            errors: {
                409: `Conflict`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Delete Barcode Link
     * @returns any Successful Response
     * @throws ApiError
     */
    public deleteBarcodeLinkApiV1BarcodesCodeObjectIdDelete({
        code,
        objectId,
    }: {
        code: string,
        objectId: number,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/v1/barcodes/{code}/{object_id}',
            path: {
                'code': code,
                'object_id': objectId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Barcode Containment
     * Move items into a container by providing barcode codes. Returns resolved object IDs.
     * @returns BarcodeContainmentResult Successful Response
     * @throws ApiError
     */
    public barcodeContainmentApiV1BarcodesContainmentPost({
        requestBody,
    }: {
        requestBody: BarcodeContainment,
    }): CancelablePromise<BarcodeContainmentResult> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/v1/barcodes/containment',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                409: `Conflict`,
                422: `Validation Error`,
            },
        });
    }
}
